export default __webpack_public_path__ + "static/media/voha-7.c105f7af.png";